<script setup lang="ts">
import { PageFeedbackProps } from './types';

defineProps<PageFeedbackProps>();

defineSlots<{
  button(): void;
}>();
</script>

<template>
  <div class="page-feedback-wrapper">
    <v-icon
      class="icon"
      color="secondary-lighten-1"
      size="288"
      :style="{ 'margin-left': `${iconOffset ? iconOffset : 0}px` }"
      >{{ icon }}</v-icon
    >
    <slot name="button" />
    <span
      v-if="message"
      class="text-h4 text-secondary-lighten-1 mt-11 opacity-50 text-pre-line text-center"
    >
      {{ message }}
    </span>
  </div>
</template>

<style lang="scss" scoped>
@use '@/styles/variables';

.page-feedback-wrapper {
  justify-self: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100%;

  .icon {
    opacity: 0.5;
  }
}
</style>
